import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { userEmailUpdate } from '../../../utilities/partnerServices';
import { response } from '../smartyStreetSlice';

export const updateEmailAPI = createAsyncThunk(
    'userEmailUpdate', userEmailUpdate
)

const initialState = {
  isEmailUpdated:false

}

const portaluserEmailUpdate = createSlice({
    name: 'portaluserEmailUpdate',
    initialState,
    reducers:{
        setIsEmailUpdate:(state, action) =>{
            state.isEmailUpdated = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateEmailAPI.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(updateEmailAPI.fulfilled, (state, action) => {
                let response = action.payload
                if(response?.ResponseDetails?.ResponseCode == '010'){
                    toast.success("Email Updated Successfully")
                    state.isEmailUpdated = true
                }else{
                    toast.warn(response?.ResponseDetails?.ResponseMessage);
                }
            })
            .addCase(updateEmailAPI.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
    },
})

export const { setIsEmailUpdate } = portaluserEmailUpdate.actions
export default portaluserEmailUpdate.reducer